import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=fb47b870"
import script from "./Leads.vue?vue&type=script&lang=ts"
export * from "./Leads.vue?vue&type=script&lang=ts"
import style0 from "./Leads.vue?vue&type=style&index=0&id=fb47b870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports